<template>
  <v-container style="height: 100%; display: flex">
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card flat>
          <v-card-title class="display-1 centered">
            Cette page n'existe pas :(
          </v-card-title>
          <div class="notfound-btn centered">
            <Button
              title="Retourner à la page d'accueil"
              @click.native="redirect('Home')"
            >
            </Button>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Button from "../components/HomeSections/SubComponents/Button";

export default {
  name: "NotFound",
  components: { Button }
};
</script>

<style scoped>
.notfound-btn {
  bottom: 0;
}
</style>
